import React, { lazy } from 'react'
import { withTitle } from '../../components/common/titleComp/TitleComp'
import CustomScroll from './customScroll'
const WebSiteDown = lazy(() => import('components/websiteDown'))

const RoutesArray = [
    {
        path: 'appDownload',
        element: withTitle({ component: WebSiteDown, title: 'App Download' }),
        hideHeader: true,
        label: 'SiteDown',
    },
    {
        path: '*',
        element: withTitle({ component: WebSiteDown, title: 'App Download' }),
        label: 'SiteDown',
    },
]

const siteDownRoutesArray = RoutesArray.map(route => {
    const withLayout = route.hideHeader ? (
        route.element
    ) : (
        <>
            <div className={'rootWrapper'}></div>
            <div className="body">
                <CustomScroll>{route.element}</CustomScroll>
            </div>
        </>
    )
    return {
        path: route.path,
        element: withLayout,
    }
})

export default siteDownRoutesArray
